import type {
  ICollectionSite,
  ICustomers,
  IDecimalValueAndUnit,
  IDeliverySites,
  IDocument,
  IEmployees,
  IHaulageJob,
  IJobSiteInfo,
  IProduct,
  IServices,
  ITrailers,
  IVehicles
} from '@/interfaces'
import Base from '../Base'
import { type JobStatusType } from '@/enum'
import type JobStatusChange from '../JobStatusChange'
import JobSiteInfo from '../JobSiteInfo'
import type { IWasteDeliverySite } from '@/interfaces/wasteDeliverySites'
import HaulagePricingMethod from '@/enum/HaulagePricingMethod'
import PriceWithUnit from '../PriceWithUnit'

class HaulageJob extends Base implements IHaulageJob {
  number: string
  status: JobStatusType
  description: string | null
  customerId: string | null
  customer: ICustomers
  wasteCollectionProviderId: string | null
  wasteCollectionProvider: IServices
  wasteCollectionSiteId: string
  wasteCollectionSite: ICollectionSite
  wasteCollectionSiteInfo: IJobSiteInfo
  wasteProductId: string
  wasteProduct: IProduct
  deliveryADPlantSiteId: string
  deliveryADPlantSite: IDeliverySites
  wasteDeliverySiteId: string
  wasteDeliverySite: IWasteDeliverySite
  deliverySiteInfo: IJobSiteInfo
  scheduleDate: string | null
  requestDate: string | null
  price: IDecimalValueAndUnit
  totalAmount: IDecimalValueAndUnit
  pricingMethod: HaulagePricingMethod
  purchaseOrderNumber: string | null
  purchaseOrderDocuments: IDocument[]
  assignedEmployeeId: string | null
  assignedEmployee: IEmployees
  assignedVehicleId: string | null
  assignedVehicle: IVehicles
  assignedEquipmentId: string | null
  assignedEquipment: ITrailers
  notes: string | null
  completedAt: string | null
  statusChangeHistory: JobStatusChange[] | null

  constructor(jobData?: any) {
    super(jobData)
    this.number = jobData?.number
    this.status = jobData?.status
    this.description = jobData?.description
    this.customerId = jobData?.customerId
    this.customer = jobData?.customer
    this.wasteCollectionProviderId = jobData?.wasteCollectionProviderId
    this.wasteCollectionProvider = jobData?.wasteCollectionProvider
    this.wasteCollectionSiteId = jobData?.wasteCollectionSiteId
    this.wasteCollectionSite = jobData?.wasteCollectionSite
    this.wasteCollectionSiteInfo = jobData?.wasteCollectionSiteInfo ?? new JobSiteInfo()
    this.wasteProductId = jobData?.wasteProductId
    this.wasteProduct = jobData?.wasteProduct
    this.deliveryADPlantSiteId = jobData?.deliveryADPlantSiteId
    this.deliveryADPlantSite = jobData?.deliveryADPlantSite
    this.wasteDeliverySiteId = jobData?.wasteDeliverySiteId
    this.wasteDeliverySite = jobData?.wasteDeliverySite
    this.deliverySiteInfo = jobData?.deliverySiteInfo ?? new JobSiteInfo()
    this.scheduleDate = jobData?.scheduleDate
    this.requestDate = jobData?.requestDate
    this.price = new PriceWithUnit(jobData?.price)
    this.totalAmount = new PriceWithUnit(jobData?.totalAmount)
    this.purchaseOrderNumber = jobData?.purchaseOrderNumber
    this.purchaseOrderDocuments = jobData?.purchaseOrderDocuments
    this.assignedEmployeeId = jobData?.assignedEmployeeId
    this.assignedEmployee = jobData?.assignedEmployee
    this.assignedVehicleId = jobData?.assignedVehicleId
    this.assignedVehicle = jobData?.assignedVehicle
    this.assignedEquipmentId = jobData?.assignedEquipmentId
    this.assignedEquipment = jobData?.assignedEquipment
    this.notes = jobData?.notes
    this.completedAt = jobData?.completedAt
    this.statusChangeHistory = jobData?.statusChangeHistory
    this.pricingMethod = jobData?.pricingMethod || HaulagePricingMethod.PerLoad
  }
}

export default HaulageJob
